import "react-bootstrap-country-select/dist/react-bootstrap-country-select.css";
import React from "react";
import CountrySelect from "react-bootstrap-country-select";

const POPPER_Z_INDEX_MODIFIER = {
  name: "zIndex",
  enabled: true,
  phase: "write",
  fn: ({ state }) => {
    state.elements.popper.style.zIndex = "1060";
  },
};

function CountryPicker({ country, onCountryChange }) {
  return (
    <CountrySelect
      value={country}
      onChange={onCountryChange}
      overlayProps={{
        popperConfig: { modifiers: [POPPER_Z_INDEX_MODIFIER] },
      }}
    />
  );
}

export default CountryPicker;
